import { useSelector } from 'react-redux';
import { HEADER_STYLES, USER_TYPES } from './HeaderConstants';
import { useHeaderNavigation } from './hooks/useHeaderNavigation';
import { useUserDropdown } from './hooks/useUserDropdown';
import { useServiceLocation } from './hooks/useServiceLocation';
import CompanyLogo from './components/CompanyLogo';
import NavigationTabs from './components/NavigationTabs';
import UserProfile from './components/UserProfile';
import ServiceLocationFilter from './components/ServiceLocationFilter';
import { LogoutIcon } from './LogoutIcon.tsx';

const AppHeader = () => {
  const loginDetails = useSelector(state => state.loginDetails);
  const loggedInUser = loginDetails.loggedInUser;
  const token = loginDetails?.jwtToken || '';
  
  console.log('=== APP HEADER DEBUG ===');
  console.log('User Type:', loggedInUser?.user_type?.toLowerCase() || '');
  console.log('Token exists:', !!token);
  console.log('Logged in user:', !!loggedInUser);
  console.log('=== END APP HEADER DEBUG ===');
  
  // Get user information
  const userType = loggedInUser?.user_type?.toLowerCase() || '';
  const userName = loggedInUser?.username || loggedInUser?.email || '';
  
  // Check if user is staff (for service location filter)
  const isStaffUser = userType === USER_TYPES.STAFF;
  
  // Hooks
  const { navigationItems, isNavigationActive, handleNavigation } = useHeaderNavigation(userType);
  const { 
    isDropdownOpen, 
    dropdownRef, 
    toggleDropdown, 
    handleProfileManagement, 
    handleLogoutClick 
  } = useUserDropdown();
  
  const {
    selectedServiceLocation,
    serviceLocations,
    selectedLocationAddress,
    handleServiceLocationChange
  } = useServiceLocation(userType, token);
  
  console.log('=== APP HEADER SERVICE LOCATION DEBUG ===');
  console.log('Selected service location:', selectedServiceLocation);
  console.log('Service locations count:', serviceLocations.length);
  console.log('Is staff user:', isStaffUser);
  console.log('=== END APP HEADER SERVICE DEBUG ===');

  return (
    <div className={HEADER_STYLES.CONTAINER}>
      {/* Company Logo */}
      <CompanyLogo />

      {/* Navigation Tabs */}
      <NavigationTabs 
        navigationItems={navigationItems}
        isNavigationActive={isNavigationActive}
        handleNavigation={handleNavigation}
      />

      {/* Right side content */}
      <div className="ml-auto flex items-center">
        {/* Service Location Filter - Only for Staff */}
        {isStaffUser && (
          <ServiceLocationFilter
            serviceLocations={serviceLocations}
            selectedServiceLocation={selectedServiceLocation}
            selectedLocationAddress={selectedLocationAddress}
            handleServiceLocationChange={handleServiceLocationChange}
          />
        )}

        {/* User Profile */}
        <UserProfile
          userName={userName}
          userType={userType}
          isDropdownOpen={isDropdownOpen}
          dropdownRef={dropdownRef}
          toggleDropdown={toggleDropdown}
          handleProfileManagement={handleProfileManagement}
        />

        {/* Logout button for all users */}
        <button
          onClick={handleLogoutClick}
          className="text-gray-600 hover:text-red-500 transition ml-2"
          title="Logout"
        >
          <LogoutIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default AppHeader;
